import * as React from 'react';
import { IStringLocalizer } from '../../../utilities/IStringLocalizer';
import { useLocalizer } from './hooks/useLocalizer';

interface AISupportedFileTypesProps {
    localizer?: IStringLocalizer;
}

/**
 * Component displaying the list of supported file types for upload
 */
export const AISupportedFileTypes: React.FC<AISupportedFileTypesProps> = ({ localizer }) => {
    const localize = useLocalizer(localizer);

    return (
        <div className="ai-supported-types-inline">
            <span className="ai-supported-types-guidance">
                {localize("Select all relevant files at once.")}
            </span>
            <span className="ai-supported-types-text">
                {localize("Supported file types:")} .pdf, .docx, .xlsx, .csv, .txt, .pptx, .xml, .jpg/.jpeg
            </span>
        </div>
    );
};

export default AISupportedFileTypes;
